import getColor from '~/lib/getColor'

export const BORDER = `1px solid ${getColor('blackAlpha15')}`
export const TEXT_H3_STYLE = {
    fontSize: '20px',
    fontWeight: 700,
    color: getColor('blackAlpha65'),
}
export const TEXT_LABEL_STYLE = {
    color: getColor('blackAlpha45'),
    minWidth: '180px',
    fontWeight: 400,
}
export const ICON_STYLE = {
    fontSize: '20px',
    marginRight: '8px',
    marginTop: '-4px',
}
